"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('riding-one', true, function (props) {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.5804 27.5139L4 28.3194V22.6806L16.2578 17.4444V10C16.2578 10 21.9781 11.4028 22.7953 12.6111C23.6124 13.8194 22.7953 16.6389 22.7953 16.6389C26.8812 18.1157 30.7843 22.6806 30.7843 26.3056C30.7843 29.9306 29 34.5 29 34.5C27.0194 34.5 26.2898 38.7917 27.5156 40",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22 26C22 28.7614 20.2091 30 18 30C15.7909 30 14 28.7614 14 26",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.3805 30C17.8186 30 18.2566 33.2 17.8186 34.8C17.3805 36.4 16.9425 37.2 13 40",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37 16C38.1046 16 39 15.1046 39 14C39 12.8954 38.1046 12 37 12C35.8954 12 35 12.8954 35 14C35 15.1046 35.8954 16 37 16Z",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeMiterlimit: "2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.9997 30C29.4347 30.0837 33.11 28.2269 34.9997 26.9336C37.272 25.3732 35.1346 22.923 37.7243 22.3785L39.549 21C39.549 21 40.9996 23.0664 41.9996 25C42.9997 26.9336 43.5997 32.9 41.9997 36.5H33.9997L36.9997 39.5",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeMiterlimit: "2",
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;